<template>
  <div class="ip-page">
    <van-nav-bar title="IP白名单" left-arrow @click-left="$router.back()" :border="false" />
    <div class="dd-card">
      <van-cell title="白名单策略" :value="config.enabled?'已开启':'已关闭'"><template #right-icon><van-switch v-model="config.enabled" size="22" @change="saveConfig" /></template></van-cell>
    </div>
    <div class="dd-section-title">IP列表</div>
    <div class="dd-card" v-if="whitelist.length>0">
      <div class="ip-item" v-for="item in whitelist" :key="item.id">
        <div class="ip-info"><div class="ip-addr">{{ item.ip }}</div><div class="ip-remark" v-if="item.remark">{{ item.remark }}</div></div>
        <van-button size="mini" type="danger" plain round @click="handleRemove(item)">删除</van-button>
      </div>
    </div>
    <div class="dd-empty" v-else><van-icon name="shield-o" size="40" /><p>暂无IP白名单</p></div>
    <div style="padding:16px"><van-button type="primary" block round icon="plus" @click="showAdd=true" style="height:44px">添加IP</van-button></div>
    <van-dialog v-model="showAdd" title="添加白名单IP" show-cancel-button confirm-button-color="#2F88FF" @confirm="handleAdd">
      <div style="padding:16px"><van-field v-model="addForm.ip" label="IP地址" placeholder="如 192.168.1.100" /><van-field v-model="addForm.remark" label="备注" placeholder="如：办公室网络" /></div>
    </van-dialog>
  </div>
</template>

<script>
import { getIPWhitelistConfig, setIPWhitelistConfig, getIPWhitelistList, addIPWhitelist, removeIPWhitelist } from '@/api'
export default {
  name: 'IPWhitelist',
  data() { return { config:{enabled:false},whitelist:[],showAdd:false,addForm:{ip:'',remark:''} } },
  created() { this.loadConfig();this.loadList() },
  methods: {
    loadConfig:function(){var self=this;getIPWhitelistConfig().then(function(res){if(res.code===0)self.config=res.data||{enabled:false}})},
    saveConfig:function(){var self=this;setIPWhitelistConfig(this.config).then(function(res){if(res.code!==0)self.$toast.fail(res.msg||'操作失败')})},
    loadList:function(){var self=this;getIPWhitelistList().then(function(res){if(res.code===0)self.whitelist=res.data||[]})},
    handleAdd:function(){if(!this.addForm.ip){this.$toast('请输入IP');return}var self=this;addIPWhitelist(this.addForm).then(function(res){if(res.code===0){self.$toast.success('添加成功');self.showAdd=false;self.addForm={ip:'',remark:''};self.loadList()}else self.$toast.fail(res.msg||'失败')})},
    handleRemove:function(item){var self=this;this.$dialog.confirm({message:'确定删除 '+item.ip+' ？'}).then(function(){removeIPWhitelist({ip:item.ip}).then(function(res){if(res.code===0){self.$toast.success('删除成功');self.loadList()}else self.$toast.fail(res.msg||'失败')})}).catch(function(){})}
  }
}
</script>

<style scoped>
.ip-page { min-height:100vh; background:#F5F6FA; }
.ip-item { display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid #F5F6FA; }
.ip-item:last-child { border-bottom:none; }
.ip-addr { font-size:14px;font-weight:600;color:#171A1D;font-family:monospace; }
.ip-remark { font-size:12px;color:#A0A4AE;margin-top:2px; }
</style>
